import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

const authenticationSelector = (state: RootState) => state.authentication;

// login form
export const loginFormSelector = createSelector(
  authenticationSelector,
  (state) => state.loginForm
);

export const loginFormDataSelector = createSelector(
  loginFormSelector,
  (state) => state.data
);

// login
export const loginSelector = createSelector(
  authenticationSelector,
  (state) => state.login
);

export const loginStatusSelector = createSelector(
  loginSelector,
  (state) => state.status
);

export const checkPublicSelector = createSelector(
  loginSelector,
  (state) => state.data.public
);

export const logoutStateSelector = createSelector(
  authenticationSelector,
  (state) => state.logout.justLogout
);

export const resetQrSelector = createSelector(
  authenticationSelector,
  (state) => state.resetQr.data
);

export const resetQrStatusSelector = createSelector(
  authenticationSelector,
  (state) => state.resetQr.status
);
